<template>
  <v-app>
      <router-view/>
  </v-app>
</template>

<script>
export default {
  name: 'App',
};
</script>
<style>
#app {
  background: var(--background-primary);
  min-height: 100vh;
  position: relative;
}

.v-application {
  background: transparent !important;
}

/* Global Vuetify Overrides */
.v-application .v-card {
  /* box-shadow: var(--shadow-md) !important; */
  border-radius: var(--radius-lg) !important;
  transition: all var(--transition-normal);
}

.v-application .v-card:hover {
  transform: translateY(-2px);
  /* box-shadow: var(--shadow-lg) !important; */
}

.v-application .v-btn {
  border-radius: var(--radius-md) !important;
  font-weight: 600 !important;
  text-transform: none !important;
  letter-spacing: 0 !important;
  transition: all var(--transition-fast) !important;
}

.v-application .v-toolbar {
  /* box-shadow: var(--shadow-md) !important; */
}

/* Modern page transitions */
.router-view {
  animation: slideUp 0.4s ease-out;
}

@keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>